@if (uiStore.isHandset()) {
<app-mobile-header [title]="'Tổng quan'" [hideBack]="true"></app-mobile-header>
}

<!-- Header -->
<div class="dashboard-header">
  @if (!uiStore.isHandset()) {
  <div class="dashboard-header__title">
    <h1><span class="dashboard-header__title-gradient">Tổng quan</span></h1>
    <p>Theo dõi và phân tích các cuộc trò chuyện và chỉ số hiệu suất</p>
  </div>
  }

  <div class="dashboard-header__toolbar">
    <div class="range-chips">
      <button
        type="button"
        class="range-chip"
        [class.range-chip--active]="activeDateRange === 'today'"
        (click)="applyDateRange('today')"
      >
        Hôm nay
      </button>
      <button
        type="button"
        class="range-chip"
        [class.range-chip--active]="activeDateRange === 'last7days'"
        (click)="applyDateRange('last7days')"
      >
        7 ngày
      </button>
      <button
        type="button"
        class="range-chip"
        [class.range-chip--active]="activeDateRange === 'last30days'"
        (click)="applyDateRange('last30days')"
      >
        30 ngày
      </button>
    </div>

    <div class="range-dates">
      <div class="modern-date-field">
        <mat-form-field appearance="outline" class="w-full custom-mat-form-field">
          <input
            matInput
            [matDatepicker]="pickerFrom"
            [value]="timeFrom"
            (dateChange)="onDateFromMatChange($event)"
            class="py-2 px-3"
          />
          <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
          <mat-datepicker #pickerFrom></mat-datepicker>
        </mat-form-field>
      </div>
      <span class="range-dates__sep">–</span>
      <div class="modern-date-field">
        <mat-form-field appearance="outline" class="w-full custom-mat-form-field">
          <input
            matInput
            [matDatepicker]="pickerTo"
            [value]="timeTo"
            (dateChange)="onDateToMatChange($event)"
            class="py-2 px-3"
          />
          <mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
          <mat-datepicker #pickerTo></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<!-- Body -->
<div class="dashboard-body dashboard-scrollable-content">
  <!-- KPI grid -->
  <section class="kpi-grid">
    <!-- Total Conversations - hero -->
    <div class="kpi-card kpi-card--hero" style="--stagger: 0">
      <div class="kpi-card__decor" aria-hidden="true"></div>
      <div class="kpi-card__head">
        <div class="kpi-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
          </svg>
        </div>
        <span class="kpi-label">Tổng cuộc trò chuyện</span>
      </div>
      <div class="kpi-card__body">
        <div class="kpi-value">{{ dataDashboard.conversation_stats?.conversations ?? 0 }}</div>
        <ng-container *ngTemplateOutlet="trendChip; context: { value: getConversationPercentage() }"></ng-container>
      </div>
    </div>

    <!-- Messages in period -->
    <div class="kpi-card kpi-card--messages" style="--stagger: 1">
      <div class="kpi-card__decor" aria-hidden="true"></div>
      <div class="kpi-card__head">
        <div class="kpi-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
        </div>
        <span class="kpi-label">Tin nhắn trong kỳ</span>
      </div>
      <div class="kpi-card__body">
        <div class="kpi-value">{{ dataDashboard.messages_this_period ?? 0 }}</div>
        @if (dataDashboard.messages_limit) {
        <div class="kpi-quota">
          <div class="kpi-quota__bar">
            <div class="kpi-quota__fill" [style.width.%]="dataDashboard.percentMessagesPeriod ?? 0"></div>
          </div>
          <div class="kpi-sub">
            {{ dataDashboard.percentMessagesPeriod ?? 0 }}% / {{ dataDashboard.messages_limit }} hạn mức
          </div>
        </div>
        }
      </div>
    </div>

    <!-- Avg response time per message -->
    <div class="kpi-card kpi-card--time" style="--stagger: 2">
      <div class="kpi-card__decor" aria-hidden="true"></div>
      <div class="kpi-card__head">
        <div class="kpi-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
        </div>
        <span class="kpi-label">Thời gian phản hồi TB / tin</span>
      </div>
      <div class="kpi-card__body">
        <div class="kpi-value">{{ (dataDashboard.statistics_message_response_time?.average_time | hoursToHMS) || '—' }}</div>
        <div class="kpi-sub">
          Min {{ (dataDashboard.statistics_message_response_time?.min_time | hoursToHMS) || '—' }}
          · Max {{ (dataDashboard.statistics_message_response_time?.max_time | hoursToHMS) || '—' }}
        </div>
      </div>
    </div>

    <!-- Satisfaction rate (CSAT) -->
    <div class="kpi-card kpi-card--csat" style="--stagger: 3">
      <div class="kpi-card__decor" aria-hidden="true"></div>
      <div class="kpi-card__head">
        <div class="kpi-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
            <line x1="9" y1="9" x2="9.01" y2="9"/>
            <line x1="15" y1="9" x2="15.01" y2="9"/>
          </svg>
        </div>
        <span class="kpi-label">Tỷ lệ hài lòng</span>
      </div>
      <div class="kpi-card__body">
        <div class="kpi-value">{{ dataDashboard.statistics_feedback?.satisfaction_rate ?? 0 }}%</div>
        <div class="kpi-sub">
          {{ dataDashboard.statistics_feedback?.like ?? 0 }} hài lòng ·
          {{ dataDashboard.statistics_feedback?.dislike ?? 0 }} không hài lòng
        </div>
      </div>
    </div>

    <!-- Peak hour -->
    <div class="kpi-card kpi-card--peak" style="--stagger: 4">
      <div class="kpi-card__decor" aria-hidden="true"></div>
      <div class="kpi-card__head">
        <div class="kpi-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 17l6-6 4 4 8-8"/>
            <polyline points="14 7 21 7 21 14"/>
          </svg>
        </div>
        <span class="kpi-label">Giờ cao điểm</span>
      </div>
      <div class="kpi-card__body">
        @if (dataDashboard.peak_hour) {
          <div class="kpi-value">{{ formatPeakHour(dataDashboard.peak_hour.hour) }}</div>
          <div class="kpi-sub">{{ dataDashboard.peak_hour.count }} tin nhắn</div>
        } @else {
          <div class="kpi-value">—</div>
          <div class="kpi-sub">Chưa có tin nhắn trong kỳ</div>
        }
      </div>
    </div>
  </section>

  <!-- Conversation trend (full width) -->
  <div class="dashboard-card--soft dashboard-card--accent-red" style="--stagger: 3">
    <div class="dashboard-card__head">
      <span class="dashboard-card__dot"></span>
      <h3 class="dashboard-card__title">Cuộc trò chuyện theo thời gian</h3>
    </div>
    <div class="chart-container animate-fade-in">
      <div #chartTotalConversationsRef class="w-full"></div>
    </div>
  </div>

  <!-- Channel donut + Feedback (1/1) -->
  <section class="bento-row bento-row--1-1">
    <div class="dashboard-card--soft dashboard-card--accent-pink" style="--stagger: 4">
      <div class="dashboard-card__head">
        <span class="dashboard-card__dot"></span>
        <h3 class="dashboard-card__title">Lượng tin nhắn theo nghiệp vụ</h3>
      </div>
      <div class="chart-container animate-fade-in" style="min-height: 260px">
        <div
          #chartChannelMessageStatistics
          class="w-full h-full"
          [class.hidden]="!hasChannelMessageData"
        ></div>
        @if (!hasChannelMessageData) {
        <div class="dashboard-empty-state">
          <svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z"/>
          </svg>
          <div class="empty-text">Chưa có tin nhắn gắn nghiệp vụ trong kỳ</div>
          <div class="empty-hint">Kiểm tra các nghiệp vụ đã cấu hình và lựa chọn của người dùng</div>
        </div>
        }
      </div>
    </div>

    <div class="dashboard-card--soft dashboard-card--accent-green" style="--stagger: 5">
      <div class="dashboard-card__head">
        <span class="dashboard-card__dot"></span>
        <h3 class="dashboard-card__title">Đánh giá phản hồi</h3>
      </div>
      <div class="feedback-stats">
        <div class="feedback-stats__item feedback-stats__item--like">
          <div class="feedback-stats__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M7 10v12"/>
              <path d="M15 5.88L14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H7V10l4.34-9.66a1.93 1.93 0 0 1 3.66.78z"/>
            </svg>
          </div>
          <div class="feedback-stats__body">
            <div class="feedback-stats__label">Hài lòng</div>
            <div class="feedback-stats__value">{{ dataDashboard.statistics_feedback?.like ?? 0 }}</div>
          </div>
        </div>
        <div class="feedback-stats__item feedback-stats__item--dislike">
          <div class="feedback-stats__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 14V2"/>
              <path d="M9 18.12L10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H17v12l-4.34 9.66a1.93 1.93 0 0 1-3.66-.78z"/>
            </svg>
          </div>
          <div class="feedback-stats__body">
            <div class="feedback-stats__label">Không hài lòng</div>
            <div class="feedback-stats__value">{{ dataDashboard.statistics_feedback?.dislike ?? 0 }}</div>
          </div>
        </div>
        <div class="feedback-stats__item feedback-stats__item--rate">
          <div class="feedback-stats__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
              <line x1="9" y1="9" x2="9.01" y2="9"/>
              <line x1="15" y1="9" x2="15.01" y2="9"/>
            </svg>
          </div>
          <div class="feedback-stats__body">
            <div class="feedback-stats__label">Tỷ lệ hài lòng</div>
            <div class="feedback-stats__value">{{ dataDashboard.statistics_feedback?.satisfaction_rate ?? 0 }}%</div>
            <div class="feedback-stats__sub">{{ dataDashboard.statistics_feedback?.total ?? 0 }} lượt đánh giá</div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Top questions + Messages by hour (1/2 each) -->
  <section class="bento-row bento-row--1-1">
    <div class="dashboard-card--soft dashboard-card--accent-amber" style="--stagger: 7">
      <div class="dashboard-card__head">
        <span class="dashboard-card__dot"></span>
        <h3 class="dashboard-card__title">Top câu hỏi phổ biến</h3>
      </div>
      <div class="top-questions" style="min-height: 260px">
        @if (hasTopQuestions) {
          <ol class="top-questions__list">
            @for (q of topQuestions; track q.question; let i = $index) {
              <li class="top-questions__item" [class.top-questions__item--podium]="i < 3">
                <span
                  class="top-questions__rank"
                  [class.top-questions__rank--gold]="i === 0"
                  [class.top-questions__rank--silver]="i === 1"
                  [class.top-questions__rank--bronze]="i === 2"
                >{{ i + 1 }}</span>
                <span class="top-questions__text" [title]="q.question">{{ q.question }}</span>
                <span class="top-questions__count">{{ q.count }}</span>
              </li>
            }
          </ol>
        } @else {
          <div class="dashboard-empty-state">
            <svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"/>
            </svg>
            <div class="empty-text">Chưa đủ câu hỏi lặp lại trong kỳ</div>
            <div class="empty-hint">Top hiển thị các câu được hỏi từ 2 lần trở lên</div>
          </div>
        }
      </div>
    </div>

    <div class="dashboard-card--soft dashboard-card--accent-blue" style="--stagger: 8">
      <div class="dashboard-card__head">
        <span class="dashboard-card__dot"></span>
        <h3 class="dashboard-card__title">Hoạt động theo giờ trong ngày</h3>
      </div>
      <div class="chart-container animate-fade-in" style="min-height: 260px">
        <div
          #chartMessagesByHourRef
          class="w-full h-full"
          [class.hidden]="!hasMessagesByHourData"
        ></div>
        @if (!hasMessagesByHourData) {
        <div class="dashboard-empty-state">
          <svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <div class="empty-text">Chưa có tin nhắn trong kỳ</div>
          <div class="empty-hint">Thử khoảng thời gian khác</div>
        </div>
        }
      </div>
    </div>
  </section>
</div>

<!-- Templates -->
<ng-template #trendChip let-value="value">
  <span
    class="trend-chip"
    [class.trend-chip--up]="value > 0"
    [class.trend-chip--down]="value < 0"
    [class.trend-chip--flat]="value === 0"
  >
    @if (value > 0) {
    <svg viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clip-rule="evenodd"/>
    </svg>
    } @else if (value < 0) {
    <svg viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M12 13a1 1 0 100 2h5a1 1 0 001-1v-5a1 1 0 10-2 0v2.586l-4.293-4.293a1 1 0 00-1.414 0L8 9.586l-4.293-4.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0L11 9.414 14.586 13H12z" clip-rule="evenodd"/>
    </svg>
    } @else {
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
      <path d="M5 10h10"/>
    </svg>
    }
    {{ value }}% so với kỳ trước
  </span>
</ng-template>
